import styled from 'styled-components';

import { FlexColumnCenterVertical, FlexRowCenterVertical } from '@main/core-ui';
import { sp } from '@main/theme';

/**
 * Styled Section Wrapper on Privacy Center pages
 * Specifies the gap between elements in the section
 */
export const StyledSectionWrapper = styled(FlexColumnCenterVertical)`
  gap: ${sp(4)};
`;

/** Gives standard gap for elements within row */
export const StyledRowContainer = styled(FlexRowCenterVertical)`
  width: 100%;
  justify-content: space-between;
  gap: ${sp(2)};
  flex-wrap: wrap;
`;

/** Gives standard gap for elements within column */
export const StyledColumnContainer = styled(FlexColumnCenterVertical)`
  gap: ${sp(2)};
`;
